<template>
	<treeselect
		class="vue-treeselect-custom-searchable"
		:multiple="false"
		:clearable="true"
		:max-height="200"
		:always-open="false"
		:append-to-body="false"
		valueFormat="object"
		:disable-branch-nodes="true"
		:normalizer="normalizer"
		:options="textTemplates"
		@select="getSelectedOption"
		:close-on-select="true"
		:searchable="true"
		:placeholder="$t('Text Templates')"
		:noResultsText="$t('No results found')"
		:defaultOptions="textTemplates"
		@search-change="searchTextTemplate"
	/>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import debounce from 'lodash/debounce';
import Treeselect from '@riophae/vue-treeselect';

export default {
	props: ['pasteFromTemplate'],
	components: {
		Treeselect
	},
	computed: {
		...mapGetters('text-templates', {
			findTextTemplatesInStore: 'find'
		}),
		textTemplates() {
			return this.findTextTemplatesInStore(this.textTemplateParams).data;
		},
	},
	data() {
		return {
			error: null,
			textTemplateParams: {
				query: {
					$limit: 5
				}
			}
		}
	},
	created() {
		this.findTextTemplates(this.textTemplateParams);
	},
	methods: {
		...mapActions('text-templates', { findTextTemplates: 'find', createTextTemplates: 'create'}),

		normalizer(item) {
			item.id = item._id;
			item.label = item.title
			return item;
		},

		getSelectedOption(node) {
			this.$emit('pasteFromTemplate', node.content);
		},

		searchTextTemplate: debounce( function (searchQuery, instanceId) {
			if (searchQuery) {
				this.textTemplateParams.query.$or = [
					{ title: { $regex: searchQuery, $options: "i" } }
				];
			} else {
				delete this.textTemplateParams.query.$or;
			}
			this.findTextTemplates(this.textTemplateParams);
		}, 200)
	},

}
</script>

<style lang="scss">
.vue-treeselect-custom-searchable {
	.vue-treeselect__control {
		max-width: 200px!important;
		border-color: #e2ebf6;
		height: 28.5px;
		.vue-treeselect__placeholder, .vue-treeselect__single-value {
			top: -3px;
			font-size: 13px;
		}
	}
	.vue-treeselect__menu {
		max-width: 200px!important;
		font-size: 13px;
	}
}
</style>
